const DOCUMENT = 'REVIEW_TIMINGS_';

const actions = {
  APPROVE: DOCUMENT + 'APPROVE',
  CHANGE_TIMINGS: DOCUMENT + 'CHANGE_TIMINGS',
  CHANGE_VALUE: DOCUMENT + 'CHANGE_VALUE',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DECLINE: DOCUMENT + 'DECLINE',
  HIDE_MODAL: DOCUMENT + 'HIDE_MODAL',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  TOUCH: DOCUMENT + 'TOUCH',

  approve: payload => ({ type: actions.APPROVE, payload }),
  changeTimings: payload => ({ type: actions.CHANGE_TIMINGS, payload }),
  changeValue: payload => ({ type: actions.CHANGE_VALUE, payload }),
  clearStore: () => ({ type: actions.CLEAR_STORE }),
  decline: payload => ({ type: actions.DECLINE, payload }),
  hideModal: payload => ({ type: actions.HIDE_MODAL, payload }),
  loadFormData: payload => ({ type: actions.LOAD_FORM_DATA, payload }),
  loadFormDataSuccess: payload => ({ type: actions.LOAD_FORM_DATA_SUCCESS, payload }),
  showModal: payload => ({ type: actions.SHOW_MODAL, payload }),
  touch: data => ({ type: actions.TOUCH, payload: data }),
};

export default actions;
